import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function TagAsForPrintedModal({
  searchParams,
  getBirthcertificatesArchive,
  birthCertificatesArchiveList,
  isLoading,
  approveTransaction,
  showTransaction,
  id,
  approving,
  isCheckingArchive,
  type,
  startAssessment,
  isAssessing,
  permissions,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState({
    remarks: '',
  });

  useEffect(() => {
    const combine = { ...searchParams, search_by: 'DETAILS' };
    getBirthcertificatesArchive(
      {
        ..._.pick(
          {
            ...combine,
            birth_date: _.get(searchParams, 'birth_date')
          },
          _.keys(c.FORM_DATA)
        ),
      },
      () => {
      }
    );
  }, []);

  const onChangeInput = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // const onApprove = (e) => {
  //   e.preventDefault();

  //   approveTransaction(
  //     id,
  //     {
  //       // remarks: 'You can now generate Reference Number for payment',
  //       status: 'PENDING',
  //     },
  //     () => {
  //       showTransaction(id);
  //       setModal({ isOpen: false });
  //       setFormData({
  //         remarks: '',
  //       });
  //     }
  //   );
  // };

  // const onReject = (e) => {
  //   e.preventDefault();

  //   ConfirmAlert(
  //     'Please input the reason.',
  //     (remarks) => {
  //       approveTransaction(
  //         id,
  //         {
  //           remarks,
  //           status: 'REJECTED',
  //         },
  //         () => {
  //           showTransaction(id);
  //           setModal({ isOpen: false });
  //           setFormData({
  //             remarks: '',
  //           });
  //         }
  //       );
  //     },
  //     () => { },
  //     {
  //       yesLabel: 'Confirm',
  //       noLabel: 'Cancel',
  //     },
  //     true
  //   );
  // };

  const onPrinted = (e) => {
    e.preventDefault();

    startAssessment(id, () => {
      approveTransaction(
        id,
        {
          remarks: formData.remarks,
          status: 'PRINTED',
        },
        () => {
          showTransaction(id);
          setModal({ isOpen: false });
          setFormData({
            remarks: '',
          });
        }
      );
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      {isCheckingArchive && (
        <div className="loading">
          <div className="spinner text-center">
            <span className="fas fa-1x fa-spin fa-spinner" />
          </div>
        </div>
      )}
      <div className="d-flex justify-content-center">
        {type === 'view' &&
          birthCertificatesArchiveList.length > 0 && (
            <div className="input-group mt-3 col-8">
              <input
                onChange={onChangeInput}
                value={formData.remarks}
                name="remarks"
                type="text"
                className="form-control"
                placeholder="Remarks"
                aria-label="Remarks"
                aria-describedby="basic-addon2"
              />
              <div className="input-group-append">
                &nbsp;
                {Acl(permissions, ['PRINT BIRTH CERTIFICATE']) && (
                  <button
                    disabled={approving || isAssessing}
                    onClick={onPrinted}
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary "
                    type="button"
                  >
                    {approving || isAssessing ? (
                      <i className="fa fa-spin fa-spinner" />
                    ) : (
                        `TAG AS PRINTED`
                      )}
                  </button>
                )}
              </div>
            </div>
          )}
        &nbsp;
        <button
          disabled={isLoading}
          type="button"
          onClick={closeModal}
          className="mt-3 btn btn-dark "
        >
          <span className="font-weight-bold">Close</span>
        </button>
      </div>
    </Modal.Body>
  );
}

TagAsForPrintedModal.propTypes = {
  id: PropTypes.string.isRequired,
  searchParams: PropTypes.instanceOf(Object).isRequired,
  birthCertificatesArchiveList: PropTypes.instanceOf(Array).isRequired,
  getBirthcertificatesArchive: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  approving: PropTypes.bool.isRequired,
  approveTransaction: PropTypes.instanceOf(Function).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  isCheckingArchive: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  startAssessment: PropTypes.instanceOf(Function).isRequired,
  isAssessing: PropTypes.bool.isRequired,
  // getPhoto: PropTypes.instanceOf(Function).isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  birthCertificatesArchiveList: _.get(api, `${c.GET_BIRTH_ARCHIVE}.list`) || [],
  isLoading: api.loading.indexOf(c.GET_BIRTH_ARCHIVE) > -1,
  approving: api.loading.indexOf(c.APPROVE_TRANSACTION) > -1,
  isCheckingArchive: api.loading.indexOf(c.GET_BIRTH_ARCHIVE) > -1,
  isAssessing: api.loading.indexOf(c.START_ASSESSMENT) > -1,
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(TagAsForPrintedModal);
